import { dateFormatter, getMonth, moneyFormater } from '../utils/formaters';
const MediationListDtoToMediantionListItem = (tableScheduleList) => tableScheduleList?.map(dto => ({
    month: getMonth(dto.vigence) || '-',
    totalValue: moneyFormater.format(dto.amount) || '-',
    id: dto.id || '-',
    date: `${dateFormatter(dto.from, true)} - ${dateFormatter(dto.to, true)}` ||
        '-',
    status: dto.status || '-',
    name: dto.measurement_name || '-',
}));
export const MediationListDtoToMediantionList = (mediationList) => ({
    itens: MediationListDtoToMediantionListItem(mediationList.data),
    pageCount: mediationList.last_page,
    rows: mediationList.total,
});
const MediationDtoToMediantionLiItem = (tableScheduleList) => tableScheduleList?.map(dto => ({
    quant: dto.quantity || '-',
    desc: dto.description || '-',
    totalValue: moneyFormater.format(dto.amount) || '-',
}));
export const MediationDtoToMediantion = (mediation) => ({
    items: MediationDtoToMediantionLiItem(mediation.items),
    month: getMonth(mediation.vigence),
    attachmentId: mediation.attachment_id,
    status: mediation.status,
    total: moneyFormater.format(mediation.items.reduce((acc, obj) => acc + obj.quantity * obj.amount, 0)) || '-',
});
export const PaymentResumeDtoToPaymentResume = (resume) => ({
    items: [
        {
            id: resume.number,
            date: resume.issue_date,
            expireDate: resume.due_date,
            value: moneyFormater.format(resume.amount),
        },
    ],
    attachmentId: resume.attachment_id,
});
export const PaymentOptionsDtoToPaymentOptions = (options) => ({
    items: [
        {
            type: options.type,
            bank: options.bank,
            code: options.code,
        },
    ],
    attachmentId: options.attachments,
});
const centerFormater = (center) => {
    return center?.map(center => ({
        id: center.costCenter,
        name: center.nome,
    }));
};
export const CostCenterDtotoCostCenter = (centers) => centers?.map(center => ({
    groupId: center.subGrupoId,
    costCenters: centerFormater(center.costCenters),
}));
